import React, { useEffect, useState } from 'react';

interface FerdowsiBackgroundProps {
  opacity?: number;
  grayscale?: number;
  brightness?: number;
  className?: string;
}

export const FerdowsiBackground: React.FC<FerdowsiBackgroundProps> = ({
  opacity = 0.05,
  grayscale = 80,
  brightness = 0.8,
  className = ''
}) => {
  const [isHighContrast, setIsHighContrast] = useState(false);
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

  useEffect(() => {
    // Check for high contrast preference
    const highContrastQuery = window.matchMedia('(prefers-contrast: high)');
    setIsHighContrast(highContrastQuery.matches);
    
    const handleHighContrastChange = (e: MediaQueryListEvent) => {
      setIsHighContrast(e.matches);
    };
    
    highContrastQuery.addEventListener('change', handleHighContrastChange);

    // Check for reduced motion preference
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    setPrefersReducedMotion(reducedMotionQuery.matches);
    
    const handleReducedMotionChange = (e: MediaQueryListEvent) => {
      setPrefersReducedMotion(e.matches);
    };
    
    reducedMotionQuery.addEventListener('change', handleReducedMotionChange);

    return () => {
      highContrastQuery.removeEventListener('change', handleHighContrastChange);
      reducedMotionQuery.removeEventListener('change', handleReducedMotionChange);
    };
  }, []);

  // Adjust opacity and filters based on accessibility preferences
  const adjustedOpacity = isHighContrast ? Math.min(opacity * 1.6, 0.08) : opacity;
  const adjustedGrayscale = isHighContrast ? 100 : grayscale;
  const adjustedBrightness = isHighContrast ? brightness * 0.75 : brightness;

  return (
    <div 
      className={`ferdowsi-background ${className}`}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundImage: 'url("/images/ferdowsi-statue.jpg")',
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        filter: `grayscale(${adjustedGrayscale}%) brightness(${adjustedBrightness}) contrast(1.1)`,
        opacity: adjustedOpacity,
        zIndex: -1,
        pointerEvents: 'none',
        transition: prefersReducedMotion ? 'none' : 'opacity 0.3s ease-in-out'
      }}
      aria-hidden="true"
      role="presentation"
    />
  );
};

export default FerdowsiBackground;